import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://dnhwudaekwesimksehmz.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRuaHd1ZGFla3dlc2lta3NlaG16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3NDc0MDEsImV4cCI6MjA3OTMyMzQwMX0.JqgBN_y-EdSL8ZJXaUCPqZ8ZmWmGRvF8CMKyMlgTH4o'

// Configure to use sessionStorage instead of localStorage
// This makes sessions expire when browser closes
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: window.localStorage,   // ← change from sessionStorage 
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})